'use strict'

import React,{Component} from 'react';
import uuid from 'uuid';
import request from 'superagent';

import Layout from './Layout.jsx';
import ProjectMenu from './components/ProjectMenu.jsx';
import IssueForm from './change/IssueForm.jsx';
import PriorityTable from './components/PriorityTable.jsx';
import priority from '../app/utils/priority.js';
import IssueReportList from './change/IssueReportList.jsx';
import LastIssueReports from './change/LastIssueReports.jsx';

import sendCommand from '../app/utils/sendCommand.js';

import Translations from '../app/utils/translations.js';

let translations=new Translations([
    require('./change/labels/english.js'),
    require('./change/labels/norwegian.js')
]);


function assignPriority(item) {
  return item.status!=="Closed"
    ? Object.assign({},item,{row:parseInt(item.priority),column:parseInt(item.severity)})
    :  Object.assign({},item,{row:undefined,column:undefined});
}

export class IssueTable extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    let tableLabels={
      row: labels.general.priority,
      column: labels.general.severity
    };
    return (
      <PriorityTable {...this.props} labels={tableLabels}/>
    );
  }
}

class ChangeOverview extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props); //(languageLabels[this.props.language] || languageLabels["english"]);
    return (

      <div style={{display:"flex", justifyContent:"center", fontFamily:"Lato", flexWrap:"wrap", maxWidth:1016}}>
        <div >
          <div style={{backgroundColor:"#f7f7f7", padding:20, marginBottom:20, display:"flex", justifyContent: "space-between", flexWrap:"wrap" }}>

              <div>
                  <div style={{fontWeight:"bold", fontSize:14 }}>
                    {labels.general.title}
                  </div>
                  <div style={{fontSize:30, fontWeight:"bold", float:"left"}}>
                    {labels.issueRegister.title}
                  </div>
                  <div style={{minWidth:200, maxWidth:300, paddingTop:50}}>
                      {labels.issueRegister.description} <br></br><br></br>
                      {labels.issueRegister.description2}
                  </div>
                </div>


                  {this.props.hideReports!==true ? (
                    <div style={{paddingLeft:20, paddingRight:15, paddingTop:40, paddingBottom:20, width:345}}>
                      <LastIssueReports {...this.props}/>
                      </div>
                    ) : <div style={{width:344}}> </div>}


                  <div style={{float:"right", paddingBottom:20, paddingRight:20, paddingTop:20, backgroundColor:"#f7f7f7"}}>
                        <IssueTable {...this.props} onSelect={this.props.editIssue}/>
                  </div>

              </div>
            </div>

            <div style={{float:"left", marginTop:30, paddingLeft: 0, width:"100%", maxWidth:1016}}>
              <div style={{textAlign: "right", paddingBottom:15}}>
                <div onClick={this.props.addIssue} style={{cursor: "pointer", fontWeight:"bold", textDecoration:"underline"}}>
                  + {labels.general.addIssue}
                </div>
              </div>
              <div>
                {this.props.items.length>0 ?(
                  <IssueReportList
                    {...this.props}
                    items={this.props.items.slice(0).sort(priority.getProfileSort(this.props.profile))}
                    onSelect={this.props.editIssue}
                  />
                ) : (
                  <div style={{maxWidth:1016, fontFamily:"Verdana, sans-serif"}}>
                    <b>{labels.general.noIssues}</b>. {labels.general.documentIssue}
                  </div>
                )}
              </div>


            </div>
      </div>


    );
  }
}

export class Change extends Component {
  constructor(props) {
    super(props);
    this.state={
      issues:(this.props.issues!==undefined ? this.props.issues : []),
      showForm:false,
      editIssue:undefined
    };
  }

  showForm(event) {
    event.preventDefault();
    if (this.props.onDetails!==undefined) {
      this.props.onDetails({show:!this.state.showForm});
    }
    this.setState({showForm:!this.state.showForm, editIssue:undefined});
  }

  editIssue(item) {
    if (this.props.onDetails!==undefined) {
      this.props.onDetails({show:true});
    }
    this.setState({showForm:true, editIssue:this.state.issues.filter(issue=>issue.id===item.id || issue.id===item)[0]});
  }

  update(issue) {
    if (issue.id!==undefined) {
      var command={type:"updateIssue", item: Object.assign({},issue,{reports:undefined}) };
      if (this.props.project.isProduct===true) {
        command=Object.assign({},command,{
          product: {id:this.props.project.id}
        })
      } else if (this.props.project.isProgramme===true) {
        command=Object.assign({},command,{
          programme: {id:this.props.project.id}
        })
      } else if (this.props.project.isRelease===true) {
        command=Object.assign({},command,{
          release: {id:this.props.project.id}
        })
      } else {
        command=Object.assign({},command,{
          project: {id:this.props.project.id}
        });
      }

      sendCommand(command)
        .then(response=>{
          var selected=response.items.filter(updatedIssue=>updatedIssue.id===issue.id)[0];
          if (selected._implemented && issue._progress==="Implement") {
            selected=undefined;
          }
          if (this.props.onDetails!==undefined) {
            this.props.onDetails({show:selected!==undefined});
          }
          this.setState({issues: response.items, showForm: selected!==undefined, editIssue:selected});
          if (this.props.onUpdate!==undefined) {
            this.props.onUpdate(response.items);
          }
        })
        .catch(error=>{
          console.log("Got error", error);
          alert("An error occured, please try again");
        });
    } else {
      var id=uuid.v4();
      var command={type:"captureIssue", item: Object.assign({},issue,{id:id})};
      if (this.props.project.isProduct===true) {
        command=Object.assign({},command,{
          product: {id:this.props.project.id}
        })
      } else if (this.props.project.isProgramme===true) {
        command=Object.assign({},command,{
          programme: {id:this.props.project.id}
        })
      } else if (this.props.project.isRelease===true) {
        command=Object.assign({},command,{
          release: {id:this.props.project.id}
        })
      } else {
        command=Object.assign({},command,{
          project: {id:this.props.project.id}
        });
      }
      sendCommand(command)
        .then(response=>{
          var selected=response.items.filter(updatedIssue=>updatedIssue.id===id)[0];
          this.setState({issues: response.items, editIssue:selected});
          if (this.props.onUpdate!==undefined) {
            this.props.onUpdate(response.items);
          }
        })
        .catch(error=>{
          console.log("Got error",error);
          alert("An error occures, please try again");
        })
    }
  }

  createIssueReport(issue,isExceptionReport) {
    var id=uuid.v4();
    var command={
      type:"createIssueReport",
      report: {
        id: id,
        issue:Object.assign({},issue,{reports:undefined}),
        exception: isExceptionReport
      }
    };
    if (this.props.project.isProduct===true) {
      command=Object.assign({},command,{
        product: {id:this.props.project.id}
      })
    } else if (this.props.project.isProgramme===true) {
      command=Object.assign({},command,{
        programme: {id:this.props.project.id}
      })
    } else if (this.props.project.isRelease===true) {
      command=Object.assign({},command,{
        release: {id:this.props.project.id}
      })
    } else {
      command=Object.assign({},command,{
        project: {id:this.props.project.id}
      });
    }
    sendCommand(command)
      .then(response=>window.location="change/issues/"+issue.id+"/reports/"+id)
      .catch(error=>{
        console.log("Got error", error);
        alert("An error occured, please try again");
      })
  }

  render() {
    var items=this.state.issues.slice(0).map(assignPriority);
    if (this.props.size!==undefined) {
      items=items.sort(priority.getProfileSort(this.props.profile)).slice(0,this.props.size)
    }
    return (
      <div>
        <div style={{marginLeft:30, paddingTop:20}}>
          {this.state.showForm ? (
            <IssueForm
              {...this.props}
              onCancel={this.showForm.bind(this)}
              onUpdate={this.update.bind(this)}
              item={this.state.editIssue}
              createReport={this.createIssueReport.bind(this)}
              hideMenu={this.props.hideMenu}
            />
          ) : (
            <ChangeOverview
              {...this.props}
              items={items}
              addIssue={this.showForm.bind(this)}
              editIssue={this.editIssue.bind(this)}
            />
          )}
        </div>
      </div>
    );
  }
}

export class IssueReport extends Component {
  render() {
    var items=this.props.items.slice(0).map(assignPriority).sort(priority.getProfileSort(this.props.profile)).slice(0,5);
    return (
      <div style={{maxwidth:1016}}>
        <IssueTable {...this.props} items={items}/>
        <div style={{paddingTop:20}}>
          <IssueReportList {...this.props} items={items}/>
        </div>
      </div>
    );
  }
}


export default class ChangePage extends Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <Change {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/Change.jsx